<template>
  <div class="technical">
    <div class="doTitle">
      <!--      <li class="tit">{{ $t("DAO.index") }}</li>-->
      <div class="sub">
        <!-- <li>{{ $t("DAO.technology1") }}</li> -->
        <p>{{ $t("DAO.come") }}</p>
      </div>
    </div>

    <div class="content clearfix">
      <div class="adv">
        <!-- <div class="adv-img">
        </div> -->
        <div class="left">
          <div class="describe">{{ $t("DAO.eco") }}</div>
          <div class="detail">{{ $t("DAO.ecoTail") }}</div>
        </div>
      </div>
      <div class="adv">
        <div class="right">
          <div class="describe" style="text-align: right">
            {{ $t("DAO.reward") }}
          </div>
          <div class="detail">{{ $t("DAO.rewardTail") }}</div>
        </div>
        <div class="adv-img"></div>
      </div>
<!-- 
      <div class="start">{{ $t("DAO.start") }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}
li {
  list-style: none;
}
.technical {
  text-align: center;
  width: 100%;
  color: #000000;
  height: 1328px;
  margin-top: 260px;
  // background: url("../../assets/pc/图@2x.png") no-repeat center / 100% 100%;
  // background-size: 100%;
  // background-position-y: 180px;
  .doTitle {
    text-align: center;
    font-size: 24px;
    .tit {
      font-size: 24px;
      font-weight: 500;
      font-family: Poppins-Medium, Poppins;
      color: #000000;
      line-height: 28px;
      -webkit-background-clip: text;
      margin-bottom: 20px;
    }
    .sub {
      li {
        text-align: center;
        font-size: 24px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        -webkit-background-clip: text;
        margin-bottom:15px;
      }
      p {
        margin: 0 auto;
        text-align: center;
        width: 1190px;
        height: 154px;
        font-size: 60px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 77px;
        -webkit-background-clip: text;
      }
    }
  }
  .content {
    width: 1200px;
    margin-top: 200px;
    display: inline-block;
    // margin-left: 10px;
    .adv {
      float: left;
      width: 550px;
      height: 874px;
      opacity: 1;
      position: relative;
      box-sizing: border-box;
      .right {
        width: 520px;
        height: 145px;
        text-align: right;
        position: relative;
        margin-top: 128px;
      }
      .left {
        width: 520px;
        height: 145px;
        text-align: left;
        position: absolute;
        bottom: 165px;
      }
    }
    .adv:nth-child(1) {
      background: url("../../assets/pc/Mask group@2x(1).png") no-repeat center /
        100% 100%;
      background-size: 100%;
      background-position: -10px -150px;
      margin-left: 25px;
    }
    .adv:nth-child(2) {
      background: url("../../assets/pc/Mask group@2x.png") no-repeat center /
        100% 100%;
      background-size: 100%;
      background-position: 0 180px;
      //  margin-left: 10px;
    }
    .describe {
      font-size: 30px;
      font-family: Poppins-Bold, Poppins;
      font-weight: bold;
      color: #000000;
      line-height: 35px;
      -webkit-background-clip: text;
    }
    .detail {
      width: 520px;
      height: 96px;
      font-size: 20px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      -webkit-background-clip: text;
      // text-align: right;
    }
  }
  .start {
    width: 785px;
    font-size: 60px;
    font-family: Poppins-Black, Poppins;
    font-weight: 900;
    color: #000000;
    line-height: 77px;
    -webkit-background-clip: text;
    margin-bottom: 5px;
  }
}
</style>
